// extracted by mini-css-extract-plugin
export default {"title":"onboarding_title__lcab1","titleIcon":"onboarding_titleIcon__0y4xr"};